export const theme = {
  colors: {
    bgDark: '#0f0b1a',
    bgDarkMid: '#1a1145',
    bgDarkEnd: '#0d1b2a',
    bgLight: '#ffffff',
    bgMuted: '#f9fafb',
    accent: '#6366f1',
    accentStrong: '#4f46e5',
    accentSoft: '#a78bfa',
    accentPale: '#c4b5fd',
    text: '#111827',
    textMuted: '#4b5563',
    textSubtle: '#6b7280',
    border: '#e5e7eb',
    error: '#ef4444',
    warning: '#f59e0b',
    success: '#22c55e',
    white: '#ffffff',
  },
  gradients: {
    dark: 'linear-gradient(135deg, #0f0b1a 0%, #1a1145 50%, #0d1b2a 100%)',
    brand: 'linear-gradient(120deg, #c4b5fd 0%, #818cf8 45%, #a78bfa 100%)',
  },
  radii: {
    sm: '10px',
    md: '16px',
    lg: '24px',
    pill: '999px',
  },
  shadows: {
    card: '0 16px 40px rgba(15, 23, 42, 0.08)',
    cardHover: '0 24px 60px rgba(79, 70, 229, 0.16)',
  },
  layout: {
    content: '1180px',
  },
} as const;

export type AppTheme = typeof theme;
